// extracted by mini-css-extract-plugin
export default {"labelledContent":"LabelledContent_labelledContent__7WKO2","labelRow":"LabelledContent_labelRow__-L9O3","labelInfoTooltipIcon":"LabelledContent_labelInfoTooltipIcon__24nhy"};